export default __webpack_public_path__ + "static/media/Facebook_icon.c0903119.svg";